import { STATE_OPTIONS } from "../pages/panel/types/site";

/** Normalize state values for comparison (e.g. "Tamil Nadu" vs "tamilnadu"). */
export const normalizeState = (state: string) =>
  (state || "").toLowerCase().replace(/\s+/g, "");

export const stateMatches = (siteState: string, filterState: string) =>
  normalizeState(siteState) === normalizeState(filterState);

/** Human-readable state label for display in read-only fields. */
export const getStateLabel = (stateValue: string) => {
  if (!stateValue) return "—";
  const match = STATE_OPTIONS.find((option) => stateMatches(option.value, stateValue));
  return match?.label || stateValue;
};

/** Map stored/API state values to form select values (e.g. "Tamil Nadu" → "tamilnadu"). */
export const normalizeStateToFormValue = (stateValue: string) => {
  if (!stateValue) return "";
  const match = STATE_OPTIONS.find((option) => stateMatches(option.value, stateValue));
  return match?.value || stateValue;
};
